import React, { useState, useEffect, useRef } from "react";
import { useReducedMotion } from "framer-motion";

/* ============================================================
   HeroMedia — plays a silent, looping hero montage, but serves a
   static poster image instead when the viewer prefers reduced
   motion or has Data-Saver on (respecting a mobile-data audience).
   Picks a lighter source + poster on small screens.
   ============================================================ */

export default function HeroMedia({ video, className, alt }) {
  const reduce = useReducedMotion();
  const [play, setPlay] = useState(false);
  const [mobile, setMobile] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const conn = navigator.connection || {};
    const saveData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || "");
    const isMobile = window.matchMedia("(max-width: 760px)").matches;
    setMobile(isMobile);
    setPlay(!reduce && !saveData);
  }, [reduce]);

  const poster = mobile ? video.posterMobile : video.poster;

  if (!play) {
    return <img src={poster} alt={alt} className={className} loading="eager" />;
  }

  return (
    <video
      ref={ref}
      className={className}
      poster={poster}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
      tabIndex={-1}
      disablePictureInPicture
      onLoadedData={() => { if (ref.current) ref.current.muted = true; }}
    >
      <source src={mobile ? video.mobile : video.desktop} type="video/mp4" />
    </video>
  );
}
